import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import type { ConfirmDialogProps } from './ConfirmDialog.types'
import { useTranslation } from 'react-i18next'
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined'

const ConfirmDialog = ({
  open,
  onDisagree,
  onAgree,
  question,
  title,
  confirmText,
  disagreeText,
  agreeColor = 'error',
  disagreeColor = 'info',
}: ConfirmDialogProps): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Dialog
      open={open}
      onClose={onDisagree}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ sx: { p: 2, borderRadius: 2 } }}
    >
      {title !== undefined ? (
        <DialogTitle
          sx={{ justifyContent: 'space-between', display: 'flex', alignItems: 'flex-start', pb: 0 }}
          id="alert-dialog-title"
        >
          {title}
        </DialogTitle>
      ) : null}
      <DialogContent sx={{ px: 1, pb: 2, zIndex: 2 }}>
        <DialogContentText id="alert-dialog-description">{question}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button size="medium" fullWidth variant="outlined" color={disagreeColor} onClick={onDisagree} autoFocus>
          {disagreeText ?? t('common.cancel')}
        </Button>
        <Button
          size="medium"
          fullWidth
          variant="contained"
          color={agreeColor}
          onClick={onAgree}
          startIcon={<DoneOutlinedIcon />}
        >
          {confirmText ?? t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog
